import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import CommonTransEN from "@krea/customer-features/translations/common/en.json";
import CommonTransFI from "@krea/customer-features/translations/common/fi.json";
import CommonTransSE from "@krea/customer-features/translations/common/sv.json";
import { formFieldsTranslations } from "@krea/shared/design-system/fields/translations";
import { loanWidgetTranslations } from "@krea/shared/features/loan-widget";

i18n.use(initReactI18next).init({
  resources: {
    sv: {
      common: CommonTransSE,
      [formFieldsTranslations.namespace]: formFieldsTranslations.sv,
      [loanWidgetTranslations.namespace]: loanWidgetTranslations.sv,
    },
    en: {
      common: CommonTransEN,
      [formFieldsTranslations.namespace]: formFieldsTranslations.en,
      [loanWidgetTranslations.namespace]: loanWidgetTranslations.en,
    },
    fi: {
      common: CommonTransFI,
      [formFieldsTranslations.namespace]: formFieldsTranslations.fi,
      [loanWidgetTranslations.namespace]: loanWidgetTranslations.fi,
    },
  },
  lng: "sv",
  fallbackLng: "sv",
  supportedLngs: ["sv", "en", "fi"],
  ns: [
    "common",
    formFieldsTranslations.namespace,
    loanWidgetTranslations.namespace,
  ],
  defaultNS: loanWidgetTranslations.namespace,
  fallbackNS: "common",
  interpolation: {
    escapeValue: false,
  },
  react: {
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li", "a"],
  },
});

export default i18n;
